import {type RefObject, useEffect} from 'react';

export const useConnectEditor = (
  containerRef: RefObject<HTMLDivElement | null>,
  editBtnRef: RefObject<HTMLButtonElement | null>,
  editable = false,
  condition?: (ev: Event) => boolean
) => {
  useEffect(() => {
    if (!editable) return;

    // When the container is clicked, pass the click to the edit button
    const triggerEdit = (e: Event) => {
      if (condition && !condition(e)) return;
      if (e.target === editBtnRef.current) return; // If the edit button itself was clicked, skip pass-through button click
      editBtnRef.current?.click();
    };
    containerRef.current?.addEventListener('click', triggerEdit);
    return () => {
      containerRef.current?.removeEventListener('click', triggerEdit);
    };
  }, [editable, containerRef, editBtnRef, condition]);
};
